import styled from '@emotion/styled';
import { Css } from '../../../../ui';
import { CardStyled } from '../../../shared/components/cards/Card/BaseCard';
import { Color } from '../../../shared/styles/Color';

const ContentCategoryTag = styled.span`
	background-color: ${Color.Surface};
	padding: 8px 12px;
	font-size: ${Css.pxToRem(12)};
	font-weight: 500;
	line-height: 14.4px;
	letter-spacing: 1px;
	text-transform: uppercase;
	border-radius: 4px;
	${CardStyled}:hover &, ${CardStyled}:focus-visible &, ${CardStyled}:has(> a:focus-visible) & {
		color: ${Color.TextBlack} !important;
	}
`;

export default ContentCategoryTag;
